import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function CopyCallItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const modalControls = useFullscreenModalControls();
    const handleSelect = (): void => {
        modalControls.open({
            type: 'COPY_CALL',
            props: {
                agencyEventId: clickParams.eventId,
            },
        });
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-copy-call"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
